module.exports = __webpack_public_path__ + "static/media/rss25speech.7a48e1d5.jpeg";